// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './AccountSettingsSection.scss'
import lockIcon from '../../../images/common/lock-account.png'
import { SecondaryButton } from '../../../components/ui_kit_quickMD/secondary-button/secondarybutton'

export const AccountSettingsSection = ({
  className = '',
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  style,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  children,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  title,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  description,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onClickEdit,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isWithLockIcon,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isWithEditBtn,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  editModeBtnHandler,
}) => (
  <div
    className={`account-settings-section-main-wrapper ${className}`}
    style={{ marginTop: isWithEditBtn ? 38 : 44, ...style }}>
    <div className='account-settings-section-header' style={{ marginBottom: isWithEditBtn ? 12 : 16 }}>
      <div
        className='account-settings-section-title-wrapper'
        style={{
          justifyContent: isWithEditBtn ? 'space-between' : 'flex-start',
        }}>
        <div>
          <div className='account-settings-section-text account-settings-section-title'>{title}</div>
          {description ?
            <div className='account-settings-section-text account-settings-section-descripition'>{description}</div>
          : null}
        </div>
        {isWithEditBtn ?
          // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
          <SecondaryButton
            btnText='Edit'
            containerStyle={{
              height: 38,
              width: 55,
              border: '1px solid #00A2B2',
              padding: 0,
              position: 'relative',
            }}
            labelStyle={{
              fontSize: 18,
              fontWeight: 400,
              letterSpacing: 1.2,
            }}
            onPress={editModeBtnHandler}
          />
        : null}
        {isWithLockIcon ?
          <img className='provider-account-settings-section-lock-icon' src={lockIcon} alt='lockIcon' />
        : null}
      </div>
      {onClickEdit ?
        <div role='presentation' onClick={onClickEdit}>
          Edit
        </div>
      : null}
    </div>
    <div className='account-settings-section-content-container'>{children}</div>
  </div>
)
